/* StudioSoie · Mega menu v8 — interactions desktop (survol avec délai d'intention, clavier, tactile) et insertion du menu mobile
   rendu en Liquid (<template data-ss-mobile-mega>) dans le tiroir du thème Booster (.mobile__navigation). */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-megamenu-root]');
  if (!root) { return; }
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab-idx]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel-idx]'));
  var openTimer = null, closeTimer = null, current = null, lastPointer = 'mouse';

  function panelFor(idx) { return root.querySelector('[data-panel-idx="' + idx + '"]'); }
  function closeAll() {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    tabs.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    panels.forEach(function (p) { p.classList.remove('is-open'); });
    current = null;
  }
  function openTab(tab) {
    clearTimeout(closeTimer);
    if (current === tab) { return; }
    tabs.forEach(function (t) { t.setAttribute('aria-expanded', t === tab ? 'true' : 'false'); });
    panels.forEach(function (p) { p.classList.toggle('is-open', p === panelFor(tab.getAttribute('data-tab-idx'))); });
    current = tab;
  }
  function scheduleClose(delay) { clearTimeout(closeTimer); closeTimer = setTimeout(closeAll, delay == null ? 140 : delay); }

  tabs.forEach(function (tab) {
    /* Survol : délai d'intention court pour ne pas ouvrir au simple passage du curseur */
    tab.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); openTimer = setTimeout(function () { openTab(tab); }, current ? 40 : 90); });
    tab.addEventListener('mouseleave', function () { clearTimeout(openTimer); scheduleClose(); });
    /* Clavier : le focus ouvre le panneau associé */
    tab.addEventListener('focus', function () { openTab(tab); });
    /* Tactile sur grand écran (tablette) : premier tap = ouverture, second = navigation */
    tab.addEventListener('click', function (e) {
      if (lastPointer === 'touch' && tab.getAttribute('aria-expanded') !== 'true') { e.preventDefault(); openTab(tab); }
    });
  });
  panels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); });
    panel.addEventListener('mouseleave', function () { scheduleClose(); });
  });
  root.addEventListener('mouseleave', function () { scheduleClose(); });
  root.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, { passive: true });
  /* Focus sortant du menu → fermeture ; liens simples (sans panneau) → fermeture */
  root.addEventListener('focusout', function (e) { if (!e.relatedTarget || !root.contains(e.relatedTarget)) { scheduleClose(60); } });
  root.querySelectorAll('.ss-megamenu__tab:not([data-tab-idx])').forEach(function (a) { a.addEventListener('mouseenter', function () { clearTimeout(openTimer); scheduleClose(80); }); a.addEventListener('focus', closeAll); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) { return; }
    var t = current; closeAll(); try { t.focus(); } catch (err) {}
  });
  document.addEventListener('click', function (e) { if (current && !root.contains(e.target)) { closeAll(); } });

  /* ---------- Menu mobile : insertion unique du <template> dans le tiroir Booster ---------- */
  var tpl = document.querySelector('template[data-ss-mobile-mega]');
  function injectMobile() {
    if (!tpl) { return true; }
    var drawer = document.querySelector('.mobile__navigation');
    if (!drawer) { return false; }
    if (drawer.querySelector('.ss-mobile-mega')) { return true; }
    drawer.querySelectorAll('.nav__link__holder').forEach(function (el) { el.setAttribute('data-ss-hidden-by-megamenu', 'true'); });
    var frag = document.importNode(tpl.content, true);
    var closeBtn = drawer.querySelector('.close-mobile-nav');
    if (closeBtn && closeBtn.nextSibling) { drawer.insertBefore(frag, closeBtn.nextSibling); }
    else { var first = drawer.querySelector('.nav__link__holder, .mobile__navigation__footer'); if (first) { drawer.insertBefore(frag, first); } else { drawer.appendChild(frag); } }
    return true;
  }
  if (!injectMobile()) {
    /* Tiroir absent au chargement (rare) : on réessaie à l'ouverture du menu mobile, puis on abandonne */
    var toggle = document.getElementById('open-mobile-nav');
    if (toggle) { toggle.addEventListener('change', injectMobile); }
    var tries = 0, iv = setInterval(function () { if (injectMobile() || ++tries > 20) { clearInterval(iv); } }, 250);
  }
})();
